<template>
    <div class="collection-manage-box">
        <flex>
            <!--居中margin-left 25%-->
            <el-form :model="form" size="small" :rules="myRules" ref="customerInfo" style="width: 50%;padding-left: 2rem" :label-position="labelPosition">
                <el-row>
                    <!--在能耗单元设置中出现-->
                    <el-col :span="20">
                        <!--在口径设置中出现-->
                        <el-form-item label="单位名称" :label-width="formLabelWidth" style="text-align: center">
                            <center>
                                <el-input v-model="form.name" disabled/>
                            </center>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--在能耗单元设置中出现-->
                    <el-col :span="20">
                        <el-form-item label="编号" :label-width="formLabelWidth">
                            <el-input v-model="form.code" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <!--在能耗单元设置中出现-->
                        <el-form-item label="联系人" :label-width="formLabelWidth" prop="contact">
                            <el-input v-model="form.contact"
                                      @blur="form.contact = form.contact.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <!--均出现-->
                        <el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
                            <el-input v-model="form.phone" @blur="form.phone = form.phone.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <!--均出现-->
                        <el-form-item label="手机" :label-width="formLabelWidth" prop="mobile">
                            <el-input v-model="form.mobile"
                                      @blur="form.mobile = form.mobile.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="20">
                        <el-form-item label="电子邮箱" :label-width="formLabelWidth" prop="email">
                            <el-input v-model="form.email" @blur="form.email = form.email.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <!--在口径设置中出现-->
                        <el-form-item label="是否启用计算" :label-width="formLabelWidth" prop="enablecalculate" >
                            <el-select v-model="form.enablecalculate" placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <!--<template slot-scope="scope">
                                <span>{{ scope.row.form.type == 'building' ? '楼宇': '停用' }}</span>
                            </template>-->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="20">
                        <el-form-item label="国家地区" :label-width="formLabelWidth" prop="areastrname">
                            <el-input
                                    v-model="form.areastrname"
                                    placeholder="请输入内容">
                            </el-input>

                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="20">
                        <el-form-item label="地址" :label-width="formLabelWidth" prop="address">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="form.address">
                            </el-input>

                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="20">
                        <el-form-item label="备注" :label-width="formLabelWidth" prop="note">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="form.note">
                            </el-input>

                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item style="float: right">
                            <el-button type="primary" @click="saveCustomerUser()">
                                保 存
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </flex>

    </div>

</template>

<script>
  import {getCustomerInfo, saveCustomerInfo} from '@/api/customerUser'
  import {
    checkNum,
    checkName,
    identifierRegex,
    mobileRegex,
    phoneRegex,
    emailRegex,
    chargingRegex,
    amountRegex
  } from '@/utils/validate'
  import Flex from "../../../../components/Flex"


  export default {
    name: 'collectionManage',
    components: {Flex},
    data() {
      return {
        inputMaxLength: 20,
        noteMaxLength: 100,
        formLabelWidth: '9rem',
        loading: false, /* 加载*/
        options: [
          {value: 0, label: '启用'},
          {value: 1, label: '不启用'}
        ],
        labelPosition:'left',
        form: {
          /* 实体对应表单数据*/
          id: '',
          name: '',
          code: '',
          note: '',
          enabled: 1,
          icon: '',
          contact: ''
        },
        myRules: {
          /* 正则*/
          contact: [{required: true, message: '联系人不能为空'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'change'
          }],
          mobile: [{required: true, pattern: mobileRegex, message: '请输入正确的手机号', trigger: 'blur'}, {
            min: 11,
            max: 11,
            message: '长度为 11 个字符',
            trigger: 'blur'
          }],
          phone: [{required: true, pattern: phoneRegex, message: '请输入正确的电话', trigger: 'blur'}, {
            min: 8,
            max: 12,
            message: '长度为 12 个字符',
            trigger: 'blur'
          }],
          email: [{required: true, pattern: emailRegex, message: '请输入正确的电子邮箱', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }],
          enablecalculate: [{required: true, message: '请选择是否启用计算'}],
          areastrname: [{min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'}],
          address: [{min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}],
          note: [{min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}]

        },
        page: {}, /* 分页对象*/
        condition: {}, /* 查询条件*/

        list: [], /* 集中器数据*/
        input: null,
        dialogTableVisible: false,
        dialogFormVisible: false,
        disabled: false/* 按钮状态*/,
        currentRow: Number/* 选中行下标*/,
        doType: String,
        customer: {}
      }
    },
    mounted() { /* 页面初始化完成加载数据*/
      console.log(this.$store.getters.userId)
      this.queryCustomerById()
    },
    methods: {
      saveCustomerUser() {
        this.$refs.customerInfo.validate((valid) => {
          if (valid) {
            saveCustomerInfo(this.form).then(response => {
              if (response.code === 200 && response.infoJson === true) {
                this.$message({
                  type: 'success',
                  message: '修改客户信息成功'
                })
              }
              else
                this.$message({
                  type: 'error',
                  message: '修改客户信息失败'
                })
              this.queryCustomerById()
            }).catch(error => {
              console.log(error);
              this.$message({
                type: 'error',
                message: '修改客户信息失败'
              })
            })
          }
        })

      },
      queryCustomerById() { /* 查询用户*/
        getCustomerInfo(this.$store.getters.customerId).then(response => {
          this.form = {}
          if (response.code === 200) {
            this.form = response.infoJson
          }
          else
            this.$message({
              type: 'error',
              message: '查询客户信息失败'
            })
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询客户信息失败'
          })
          console.log(error)
        })
      },
      success(type) { /* 成功提示*/
        this.$notify({
          title: ' 成功',
          message: type + '集中器信息成功',
          type: 'success',
          duration: 2000
        })
      },
      handleSizeChange(size) { /* 改变条数*/
        this.page.size = size
        this.selectCollection()
      },
      handleCurrentChange(val) { /* 改变页数*/
        this.page.current = val
        this.selectCollection()
      }
    }

  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .collection-manage-box {
        display: flex;
        padding-top: 2rem;
        width: 100%;
        height: calc(100% - 2rem);
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .customer {

        }
    }


</style>